import { render, staticRenderFns } from "./Modelo.vue?vue&type=template&id=25f965da&scoped=true&lang=pug&"
import script from "./Modelo.vue?vue&type=script&lang=js&"
export * from "./Modelo.vue?vue&type=script&lang=js&"
import style0 from "./Modelo.vue?vue&type=style&index=0&id=25f965da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f965da",
  null
  
)

export default component.exports